// Module
var code = "<modal title=\"{{'Create Appeal' | translate}}\" save=$ctrl.save() cancel=$hide()> <input ng-model=$ctrl.name class=form-control placeholder=\"{{ 'Appeal Name' | translate }}\" required/> </modal> ";
// Exports
module.exports = code;